import type { EdgeState } from '../edges';
import type { NodeState, WorkflowNodeType } from '../nodes/types';

// Vertical layers (zIndex) of elements in the canvas
export enum CanvasElementLayers {
  FADED_EDGES = -2,
  DEEMPHASIZED_EDGES = -1,
  EDGES = 0,

  // since snippets exist on top of their respective snippet cards,
  // their z indexing is on top of normal nodes and normal edges
  SNIPPET_NODES = 1,
  SNIPPET_FOCUSED_NODES = 2,
  FADED_SNIPPET_EDGES = 3,
  DEEMPHASIZED_SNIPPET_EDGES = 4,
  SNIPPET_EDGES = 5,

  FOCUSED_EDGES = 6,
  NODES = 7,
  PANELS = 8,
}

export const snippetNodeLayers: Partial<Record<NodeState, CanvasElementLayers>> = {
  focused: CanvasElementLayers.SNIPPET_FOCUSED_NODES,
  'focused-hovered': CanvasElementLayers.SNIPPET_FOCUSED_NODES,
  hovered: CanvasElementLayers.SNIPPET_FOCUSED_NODES,
  highlighted: CanvasElementLayers.SNIPPET_FOCUSED_NODES,
  normal: CanvasElementLayers.SNIPPET_NODES,
};

export const snippetEdgeLayers: Partial<Record<EdgeState, CanvasElementLayers>> = {
  focused: CanvasElementLayers.FOCUSED_EDGES,
  deemphasized: CanvasElementLayers.DEEMPHASIZED_SNIPPET_EDGES,
  faded: CanvasElementLayers.FADED_SNIPPET_EDGES,
  normal: CanvasElementLayers.SNIPPET_EDGES,
};

export const edgeLayers: Partial<Record<EdgeState, CanvasElementLayers>> = {
  focused: CanvasElementLayers.FOCUSED_EDGES,
  deemphasized: CanvasElementLayers.DEEMPHASIZED_EDGES,
  faded: CanvasElementLayers.FADED_EDGES,
  normal: CanvasElementLayers.EDGES,
};

export const typeSortOrder: Record<WorkflowNodeType, number> = {
  // input attributes are children of the folder node so the ordering here is critical
  folder: 0,
  inputAttribute: 1,
  snippet: 2,
  riskCalculation: 3,
  // the order of the following nodes can be changed if desired
  service: 4,
  tag: 5,
  outputAttribute: 6,
  matrixModel: 7,
  // irrelevant for type sorting
  exit: 99,
  importedTailNode: 99,
  outcome: 99,
  outcomeReason: 99,
  preview: 99,
  skeleton: 99,
  workflow: 99,
};
